import { mergeRecord } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  GoalsOrganizationLoadByIdFulfilledAction,
  GoalsOrganizationTeamsLoadMoreFulfilledAction,
} from '../../domains/goalsOrganizations/actions.types';
import {
  GoalsTeamLoadByIdFulfilledAction,
  GoalsTeamLoadMoreGoalsFulfilledAction,
} from '../../domains/goalsTeams/actions.types';
import { GroupGoalsLoadAction } from '../../domains/groupGoals/actions.types';

import { GoalsTeam, GoalsTeams } from './types';

export const initialState: GoalsTeams = {};

type GoalsTeamsActions =
  | GoalsOrganizationLoadByIdFulfilledAction
  | GoalsOrganizationTeamsLoadMoreFulfilledAction
  | GoalsTeamLoadByIdFulfilledAction
  | GoalsTeamLoadMoreGoalsFulfilledAction
  | GroupGoalsLoadAction;

const addOrUpdateGoalsTeams = (state: GoalsTeams, goalsTeams: GoalsTeams | undefined) => {
  if (!goalsTeams) {
    return state;
  }

  return Object.keys(goalsTeams).reduce((newState, teamId) => mergeRecord(newState, teamId, goalsTeams[teamId]), state);
};

const loadMoreFulfilled = (state: GoalsTeams, goalsTeamId: GoalsTeam['id'], goalsTeams: GoalsTeams) => {
  const incomingGoalsList = goalsTeams[goalsTeamId]?.goalsList;
  if (!incomingGoalsList) {
    return state;
  }
  const incomingGoalsIds = incomingGoalsList.goalsIds;
  const currentGoalsIds = state[goalsTeamId]?.goalsList?.goalsIds || [];
  const mergedGoalsIds = [...currentGoalsIds, ...incomingGoalsIds];

  const mergedGoalsList = {
    ...incomingGoalsList,
    goalsIds: mergedGoalsIds,
  };

  return mergeRecord(state, goalsTeamId, { goalsList: mergedGoalsList });
};

const reducer: Reducer<GoalsTeams, GoalsTeamsActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'GOALS_ORGANIZATIONS.LOAD_BY_ID_FULFILLED':
      return addOrUpdateGoalsTeams(state, action.payload.entities.goalsTeams);

    case 'GOALS_ORGANIZATIONS.LOAD_MORE_TEAMS_FULFILLED':
      return addOrUpdateGoalsTeams(state, action.payload.entities.goalsTeams);

    case 'GOALS_TEAMS.LOAD_BY_ID_FULFILLED':
      return addOrUpdateGoalsTeams(state, action.payload.entities.goalsTeams);

    case 'GROUP_GOALS.LOAD_FULFILLED':
      return addOrUpdateGoalsTeams(state, action.payload.entities.goalsTeams);

    case 'GOALS_TEAMS.LOAD_MORE_GOALS_FULFILLED':
      return loadMoreFulfilled(state, action.payload.goalsTeamId, action.payload.entities.goalsTeams);

    default:
      return state;
  }
};

export default reducer;
